<template>
  <b-card no-body class="menu-card overflow-hidden">
    <b-row no-gutters cols-xs="1" cols-sm="2">
      <b-col cols="12" sm="2">
        <b-card-body class="date-body">
          <b-card-text class="date-text d-flex justify-content-left">
            {{ date }}
            <span v-if="isNew(date)" class="new-badge">New!</span>
          </b-card-text>
        </b-card-body>
      </b-col>
      <b-col cols="12" sm="10">
        <b-card-body class="information-body">
          <b-card-text class="information-text d-flex justify-content-left">
            {{ information }}
          </b-card-text>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: "InformationSpaceItem",
  props: ["date", "information"],
  methods: {
    isNew(dateString) {
      const itemDate = new Date(dateString);
      const now = new Date();
      const daysDiff = (now - itemDate) / (1000 * 60 * 60 * 24);

      // 30日以内なら NEW を表示
      return daysDiff <= 30;
    }
  }
};
</script>

<style scoped>
.date-body {
  padding: 0 0 0 0;
}
.information-body {
  padding: 0 0 0 1.5rem;
}

.new-badge {
  display: inline-block;
  background-color: rgba(81, 5, 15, 0.15);
  color: rgba(81, 5, 15, 0.7);
  font-size: 0.75em;
  font-weight: bold;
  padding: 3px 8px;
  margin-left: 10px;
  border-radius: 4px;
  vertical-align: middle;
  letter-spacing: 0.5px;
  border: 1px solid rgba(81, 5, 15, 0.12);
}
</style>